export const WEST_PILE_GAP = 42;

export const CARD_GAP_DESKTOP = 33;
export const CARD_GAP_DESKTOP_SMALL = 26;

export const CARD_GAP_TABLET = 33;
export const CARD_GAP_TABLET_SMALL = 26;

export const CARD_GAP_MOBILE = 26;
export const CARD_GAP_MOBILE_SMALL = 21;

export const COVER_CARD_GAP_DESKTOP = 10;
export const COVER_CARD_GAP_MOBILE = 9;

export const TABLET_WIDTH_BREAK_POINT = 744;
export const DESKTOP_WIDTH_BREAK_POINT = 1024;

export const BOARD_WIDTH_DESKTOP = 708;
export const BOARD_WIDTH_TABLET = 696;
export const BOARD_WIDTH_MOBILE = 372;

export const WAST_PILE_Z_INDEX = 150;
export const FOUNDATION_Z_INDEX = 99;
export const STOCK_PILE_Z_INDEX = 350;
export const MOVE_Z_INDEX = 9000;
export const DROP_Z_INDEX = 5000;
export const COLUMN_Z_INDEX = 1000;
export const OVERLAY_Z_INDEX = 90000;

export const DESKTOP_SIDEBAR_WIDTH = 120;
export const DESKTOP_UI_WIDTH = 392;
export const SETTINGS_WIDTH = 471;

export const BUTTONS_PADDING = 18;
export const BUTTONS_BOTTOM_MARGIN_DESKTOP = 28;
export const BUTTONS_MARGIN_TABLET = 24;
export const BUTTONS_MARGIN_MOBILE = 16;

export enum Displays {
    DESKTOP = 'DESKTOP',
    TABLET = 'TABLET',
    MOBILE = 'MOBILE',
}
